module.exports = __webpack_public_path__ + "images/b6df6f2b63308d45076048268f0bfb23-bedroom-fallback.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/bedroom-fallback.jpg
// module id = ./src/assets/images/content/bedroom-fallback.jpg
// module chunks = 0